'use strict';
import $ from 'jquery';
import Mustache from 'mustache';
import * as Reviews from '../api/reviews';
import * as Ellipsis from '../util/ellipsis';

const $reviewsContainer = $('.js-reviews-container'),
	productId = $reviewsContainer.data('product'),
	mustacheTitle = $('.js-review-title').html(),
	mustacheReview = $('.js-review-container').html(),
	reviews = {},
	reviewsInPage = 4;

let remaining;
let page = 1;

/**
 * @param {jQuery} $star
 * @param {Boolean} persist
 */
const setRating = ($star, persist) => {
	$star.prevAll().add($star).addClass('fill');
	$star.nextAll().removeClass('fill');
	if (persist) {
		const rating = $star.data('value');
		if (rating) {
			$star.closest('.product-review-stars')
				.data('rating', rating)
				.next('.product-review-rating')
				.text(`${rating} / 5`);
		}
	}
}

const clearRating = $stars =>
	$stars.children().removeClass('fill').next('.product-review-rating').text('');

export default () => {
	const $box = $('.product-review-box');
	const $star = $box.find('.product-review-star');

	$star.on('mouseenter', (e) => {
		const star = $(e.target);
		setRating(star);
	});

	$star.on('click', (e) => {
		const star = $(e.target);
		setRating(star, true);
	});

	$box.find('.product-review-stars').on('mouseleave', (e) => {
		const $container = $(e.currentTarget);
		const {rating} = $container.data();
		if (parseInt(rating) === 0 || !rating) {
			clearRating($container);
		} else {
			const $star = $container.find(`.product-review-star[data-value="${rating}"]`);
			setRating($star);
		}
	});

	// Product page reviews
	if ($reviewsContainer.length > 0) {

		$('.js-review-container').html('');
		$('.js-review-title').html('');

		Reviews.getAverage(productId).then(response => {
			reviews.total = response;

			if (response.count > 1 || response.count === 1 && parseFloat(response.number) > 2) { // Show only reviews if more than 1 or 1 over 2 given stars
				$('.js-review-title').html(Mustache.render(mustacheTitle, response));

				addReviews();

				// Load more button
				$reviewsContainer.find('.js-load-more').on('click', function(e) {
					e.preventDefault();
					page++;
					addReviews();
				});
			}
		});

	}

	/**
   * Get reviews from stage using promise
   */
	function addReviews () {
		Reviews.getReviews(productId, page, reviewsInPage).then(response => {
			$('.js-review-container').append(Mustache.render(mustacheReview, response));

			const addedIds = response.map(res => res.uuid);
			const addedReviews = $('.js-review-item').filter(review => {
				const item = $('.js-review-item').eq(review);
				if (addedIds.includes(item.data('id'))) {
					return item;
				}
			});

			// Load more count
			remaining = reviews.total.count - $reviewsContainer.find('.js-review-item').length;
			remaining > 0 ? $reviewsContainer.find('.js-load-more span').html(remaining) : $reviewsContainer.find('.js-load-more').addClass('hidden');

			$.each($reviewsContainer.find('.js-review-item'), function (i) {
				Ellipsis.truncate($(this).find('.js-ellipsis'), 120, '...');
			});

			voting(addedReviews);
			$reviewsContainer.removeClass('hidden');
		});
	}

	/**
   * Enable voting for review if there is comment or text review
   * @param {object} $vote HTML object of new review
   */
	function voting ($vote) {
		if ($vote.length > 0) {
			$.each($vote, function (i) {
				const $el = $(this),
					reviewId = $el.data('id');

				function processVotes () {
					$el.find('.button').removeClass('selected');
					if (localStorage.getItem(`intersport-review-${$el.data('id')}`) === 'upvote') {
						$el.find('.button[data-value="upvote"]').addClass('selected');
					}

					if (localStorage.getItem(`intersport-review-${$el.data('id')}`) === 'downvote') {
						$el.find('.button[data-value="downvote"]').addClass('selected');
					}
				}

				processVotes();

				$el.find('.button').on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					if (!$(this).hasClass('selected')) {
						let ls = localStorage.getItem(`intersport-review-${$el.data('id')}`);
						const vote = $(this).data('value');
						const action = (ls === 'upvote' && vote === 'downvote') ||(ls === 'downvote' && vote === 'upvote') ? 'change' : 'add';
						Reviews.vote(reviewId, vote, action);
						localStorage.setItem(`intersport-review-${$el.data('id')}`, vote);
						$(this).find('.count').text(Number($(this).find('.count').text()) + 1);
						if (action === 'change') {
							$el.find('.button').not($(this)).find('.count').text(Number($el.find('.button').not($(this)).find('.count').text()) - 1);
						}
						processVotes();
					}
				});
			});
		}
	}

}
